<template>
  <div class="free-days-display">
    <div class="flex align-items-center gap-3">
      <!-- Free Days Count -->
      <div class="flex align-items-center gap-2">
        <i class="pi pi-calendar text-blue-500"></i>
        <span class="font-semibold text-gray-800">{{ freeDaysCount }} days</span>
      </div>
      
      <!-- Status Badge -->
      <!-- <div class="flex align-items-center gap-2">
        <Tag 
          :value="statusText" 
          :severity="statusSeverity"
          :icon="statusIcon"
          class="text-xs"
        />
      </div> -->
      
      <!-- Anti-fraud bypass indicator -->
      <div v-if="canBypassAntiFraud" class="flex align-items-center gap-1">
        <i class="pi pi-shield text-green-500 text-sm"></i>
        <span class="text-green-600 text-xs font-medium">Can bypass anti-fraud</span>
      </div>
    </div>
    
    <!-- Additional info -->
    <div v-if="expirationDate || source" class="mt-2 text-xs text-gray-500">
      <div v-if="expirationDate" class="mb-1">
        <i class="pi pi-clock mr-1"></i>
        Expires: {{ formatExpirationDate(expirationDate) }}
      </div>
      <div v-if="source">
        <i class="pi pi-info-circle mr-1"></i>
        Source: {{ source }}
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'FreeDaysDisplay',
  props: {
    context: {
      type: Object,
      required: true
    },
    field: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const freeDaysCount = computed(() => props.context?.freeDays || 0)
    const canBypassAntiFraud = computed(() => props.context?.freeDaysCanBypassAntiFraud || false)
    const expirationDate = computed(() => props.context?.freeDaysExpiresAt)
    const source = computed(() => props.context?.freeDaysSource)
    
    const statusText = computed(() => {
      if (freeDaysCount.value === 0) {
        return 'No free days'
      }
      
      if (expirationDate.value && isExpired(expirationDate.value)) {
        return 'Expired'
      }
      
      return 'Active'
    })
    
    const statusSeverity = computed(() => {
      if (freeDaysCount.value === 0) {
        return 'secondary'
      }
      
      if (expirationDate.value && isExpired(expirationDate.value)) {
        return 'danger'
      }
      
      return 'success'
    })
    
    const statusIcon = computed(() => {
      if (freeDaysCount.value === 0) {
        return 'pi pi-times'
      }
      
      if (expirationDate.value && isExpired(expirationDate.value)) {
        return 'pi pi-exclamation-triangle'
      }
      
      return 'pi pi-check'
    })
    
    function isExpired(dateString) {
      if (!dateString || dateString === '0001-01-01T00:00:00Z') {
        return false
      }
      
      try {
        const expirationDate = new Date(dateString)
        const now = new Date()
        return expirationDate < now
      } catch {
        return false
      }
    }
    
    function formatExpirationDate(dateString) {
      if (!dateString || dateString === '0001-01-01T00:00:00Z') {
        return 'Never'
      }
      
      try {
        return new Date(dateString).toLocaleDateString('da-DK', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch {
        return 'Invalid date'
      }
    }
    
    return {
      freeDaysCount,
      canBypassAntiFraud,
      expirationDate,
      source,
      statusText,
      statusSeverity,
      statusIcon,
      formatExpirationDate
    }
  }
}
</script>

<style scoped>
.free-days-display {
  padding: 0.5rem 0;
}

.free-days-display .p-tag {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
